import React from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import { motion, useReducedMotion } from "framer-motion";

const MotionBox = motion.create(Box);
const MotionImage = motion.create(Image);

export default function ProfileLayout({ children, mascot, mobileWelcome = false, feedbackKind }) {
  const reduceMotion = useReducedMotion();
  const feedbackTone = feedbackKind === "success"
    ? { bg: "#d7f0df", border: "#68a97a", darkBg: "#193b29", darkBorder: "#55a36e" }
    : ["missing", "provider", "neutral"].includes(feedbackKind)
      ? { bg: "#f8e8b8", border: "#d0a83d", darkBg: "#463817", darkBorder: "#caa646" }
      : { bg: "#f7d7d7", border: "#cf6a6a", darkBg: "#482323", darkBorder: "#c96363" };
  return (
    <Box bg="#f1f3f6" color="gray.800" _dark={{ bg: "#171a21", color: "gray.100" }} minH={{ base: "100dvh", lg: mobileWelcome ? "auto" : undefined }} position="relative" overflow="hidden" pt={{ base: "76px", md: "104px" }} pb={{ base: mobileWelcome ? "6" : "12", md: "20" }}>
      {mobileWelcome && <>
        <Box display={{ lg: "none" }} position="absolute" boxSize="190px" rounded="full" bg="#dce8f1" right="-96px" top="16%" opacity=".72"/>
        <Box display={{ lg: "none" }} position="absolute" w="210px" h="90px" rounded="full" bg="#eadde8" left="-105px" bottom="5%" transform="rotate(-16deg)" opacity=".68"/>
        <Box display={{ lg: "none" }} position="absolute" boxSize="54px" rounded="18px" bg="#cf7d79" right="9%" bottom="8%" transform="rotate(24deg)" opacity=".18"/>
      </>}
      <Flex w="full" maxW="980px" minH={mobileWelcome ? { base: "calc(100dvh - 82px)", md: "620px" } : { md: "620px" }} position="relative" zIndex="1" mx="auto" px={{ base: "5", sm: "7", md: "10" }} direction={{ base: "column", lg: "row" }} justify={mobileWelcome ? { base: "center", lg: "flex-start" } : undefined} align={{ lg: "center" }} gap={{ base: "2", lg: "20" }}>
        <MotionBox
          w="full"
          maxW={{ base: "520px", lg: "480px" }}
          mx={{ base: "auto", lg: "0" }}
          css={{
            "& input": {
              background: "#f8f9fb",
              color: "#2d3748",
              borderColor: "#d9d1c5",
            },
            "& [role='status']": {
              background: feedbackTone.bg,
              border: `1px solid ${feedbackTone.border}`,
              borderRadius: "14px",
              boxShadow: "0 8px 20px rgba(75,58,45,.10)",
            },
          }}
          _dark={{
            "& h1, & h2, & h3": { color: "gray.100" },
            "& p": { color: "gray.300" },
            "& input": { background: "#222733", color: "#edf0f5", borderColor: "#485164" },
            "& [role='status']": {
              background: feedbackTone.darkBg,
              borderColor: feedbackTone.darkBorder,
              boxShadow: "0 8px 22px rgba(0,0,0,.24)",
            },
          }}
          initial={reduceMotion ? false : { opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .25 }}
        >
          {children}
        </MotionBox>
        <Flex display={{ base: "none", lg: "flex" }} flex="1" minH="540px" position="relative" overflow="hidden" rounded="48px 18px 48px 18px" bg="linear-gradient(145deg, #dce8f1 0%, #eadde8 54%, #e7e3ee 100%)" _dark={{ bg: "linear-gradient(145deg, #243746 0%, #3d3040 54%, #302f43 100%)" }} align="center" justify="center">
          <Box position="absolute" boxSize="190px" rounded="full" bg="#b8d5e6" top="-45px" right="-36px" opacity=".78"/>
          <Box position="absolute" boxSize="130px" rounded="38px" bg="#d7bfd8" bottom="35px" left="-38px" transform="rotate(24deg)" opacity=".78"/>
          <Box position="absolute" w="170px" h="34px" rounded="full" bg="#cf7d79" bottom="70px" right="54px" opacity=".24"/>
          <MotionImage
            key={mascot}
            src={mascot}
            alt="Wako, mascota de Arawaks"
            w="full"
            maxW="360px"
            maxH="390px"
            objectFit="contain"
            position="relative"
            zIndex="1"
            filter="drop-shadow(0 20px 26px rgba(127,29,29,.16))"
            initial={reduceMotion ? false : { opacity: 0, scale: .92 }}
            animate={{ opacity: 1, scale: 1, y: reduceMotion ? 0 : [0, -7, 0] }}
            transition={{ opacity: { duration: .25 }, scale: { duration: .25 }, y: { duration: 2.8, repeat: Infinity, ease: "easeInOut" } }}
          />
        </Flex>
      </Flex>
    </Box>
  );
}
